import './Intro.scss';

import React, { useState } from 'react';

import { Confirm } from '../../Modal';
import { IntroCode } from '../../Code';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';

export function PlayButton(): JSX.Element {
    return (
        <svg
            enableBackground="new 0 0 128 128"
            height="128px"
            version="1.1"
            viewBox="0 0 128 128"
            width="128px"
        >
            <path
                d="M107.574,55.165L38.623,15.364C37.044,14.452,35.287,14,33.524,14c-1.762,0-3.519,0.453-5.096,1.365  c-3.157,1.82-5.098,5.186-5.098,8.831v79.611c0,3.644,1.94,7.008,5.098,8.83c1.577,0.912,3.334,1.363,5.096,1.363  c1.763,0,3.52-0.451,5.099-1.363l68.951-39.811c3.153-1.822,5.095-5.186,5.095-8.832C112.669,60.351,110.728,56.987,107.574,55.165z  "
                fill="#FF6D72"
            />
        </svg>
    );
}

function IntroCodeBlock(): JSX.Element {
    const [dialogResult, setDialogResult] = useState<boolean>();

    const resultText =
        dialogResult !== undefined
            ? dialogResult
                ? 'Removal allowed'
                : 'Removal not confirmed'
            : '';

    return (
        <div className="intro__code code">
            <div
                className="ic__run"
                onClick={async () => {
                    const isConfirm = await Confirm(
                        'Are you sure you want to delete the entry?',
                        'You cannot undo this action'
                    );

                    setDialogResult(isConfirm);
                }}
            >
                <PlayButton />
            </div>
            <SyntaxHighlighter language="typescript" style={github}>
                {IntroCode}
            </SyntaxHighlighter>
            <div className="ic__resultDialog">
                {dialogResult !== undefined && <span>Confirmation result: </span>}
                {resultText}
            </div>
        </div>
    );
}

export function Intro(): JSX.Element {
    return (
        <main className="intro">
            <div className="intro__text">
                <h1>Simple and powerful modal dialog component for React</h1>

                <p>
                    React St Modal is a simple and flexible library for implementing modal dialogs. 
                </p>

                <h2>Features</h2>

                <ul>
                    <li>Simple and easy to use api</li>
                    <li>Compatible with mobile devices</li>
                    <li>Implemented standard interaction functions: alert, confirm, prompt</li>
                    <li>Async/await syntax</li>
                    <li>Customization via css variables</li>
                    <li>Accessibility and focus control</li>
                    <li>Dynamic call of modal dialogs, which does not require definition in JSX code</li>
                    <li>No third party libraries</li>
                </ul>
            </div>
            <IntroCodeBlock />
        </main>
    );
}
